document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("bongzi-popup");

  if (!popup) return;

  const closeBtn = popup.querySelector(".bongzi-popup-close");
  const overlay = popup.querySelector(".bongzi-popup-overlay");

  const delay = Number(popup.dataset.delay || 5) * 1000;

  function openPopup() {
    if (sessionStorage.getItem("popupShown")) return;

    popup.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closePopup() {
    popup.classList.remove("active");
    document.body.style.overflow = "";
    sessionStorage.setItem("popupShown", "true");
  }

  setTimeout(openPopup, delay);

  closeBtn.addEventListener("click", closePopup);

  overlay.addEventListener("click", closePopup);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closePopup();
    }
  });

  document.addEventListener("mouseleave", (e) => {
    if (
      e.clientY <= 0 &&
      !popup.classList.contains("active") &&
      !sessionStorage.getItem("popupShown")
    ) {
      openPopup();
    }
  });

});